import { IPayrollPayType, PostPayTypeRequest, PutPayTypeRequest } from '$models'
import { singletonQueryClient } from '$utils'
import { coreApi } from '$api'
import { PayrollSystem } from '$constants'

enum QueryKeys {
  GetAllPayTypes = 'all-pay-types',
  GetPayTypesFromPaySystem = 'pay-types-from-pay-system',
}

/**
 * Get custom and default pay types
 * @returns a list of IPayrollPayType
 */
export const GetAllPayTypes = async (): Promise<IPayrollPayType[]> => {
  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.GetAllPayTypes],
    queryFn: async ({ signal }) => {
      return coreApi.getAllPayTypes(signal)
    },
  })
}

/**
 * Get all pay types from a certain payroll system
 * @returns a list of IPayrollPayType
 */
export const getPayTypesFromPaySystem = async (
  payrollSystem: PayrollSystem
): Promise<IPayrollPayType[]> => {
  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.GetPayTypesFromPaySystem, payrollSystem],
    queryFn: async ({ signal }) => {
      return await coreApi.getPayTypesFromPayrollSystem(payrollSystem, signal)
    },
  })
}

/**
 * Get all default pay types
 * @returns a list of IPayrollPayType
 */
export const getAllDefaultPayTypes = async (): Promise<IPayrollPayType[]> => {
  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.GetPayTypesFromPaySystem],
    queryFn: async ({ signal }) => {
      return await coreApi.getAllDefaultPayTypes(signal)
    },
  })
}

/**
 * Create a payroll pay type
 * @param payTypeName the name of the pay type
 * @param payCode the pay code of the pay type
 * @returns the created payroll pay type
 */
export const createPayType = async (
  payTypeName: string,
  payCode: string | undefined
): Promise<IPayrollPayType> => {
  return await coreApi.createPayType(
    new PostPayTypeRequest({ payType: payTypeName, payCode })
  )
}

/**
 * Update a payroll pay type
 * @param payrollPayType the payroll pay type to update
 * @returns the updated payroll pay type
 */
export const updatePayType = async (
  payrollPayType: IPayrollPayType
): Promise<IPayrollPayType> => {
  const { id, payCode, payType, deletedAt } = payrollPayType

  return await coreApi.updatePayType(
    new PutPayTypeRequest({ payCode, id, payType, deletedAt })
  )
}

/**
 * Delete a payroll pay type
 * @param id the payroll pay type id to be deleted
 */
export const deletePayType = async (id: string): Promise<void> => {
  return await coreApi.deletePayType(id)
}
